import { render, staticRenderFns } from "./TransferTaskOwnership.vue?vue&type=template&id=273bd998&scoped=true&"
import script from "./TransferTaskOwnership.vue?vue&type=script&lang=js&"
export * from "./TransferTaskOwnership.vue?vue&type=script&lang=js&"
import style0 from "./TransferTaskOwnership.vue?vue&type=style&index=0&id=273bd998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273bd998",
  null
  
)

export default component.exports